import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import RoleDropdown from "./RoleDropdown";

const AssistantDetail = ({
  selectedAssistant,
  isNew,
  UpdateAssistantData,
  showModal,
  setShowModal,
  btnloading,
}) => {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    role: "",
    password: "",
  });

  const [emailError, setEmailError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (
      !isNew &&
      selectedAssistant &&
      Object.keys(selectedAssistant).length > 0
    ) {
      setFormData({
        id: selectedAssistant.id || "",
        name: selectedAssistant.name || "",
        email: selectedAssistant.email || "",
        status: selectedAssistant.status || "",
        role: selectedAssistant.role || "",
        password: selectedAssistant.password || "",
      });
    } else {
      // Save Case: Default empty values for new entry

      setFormData({
        id: "",
        name: "",
        email: "",
        status: "active",
        role: "",
        password: "",
      });
    }
  }, [selectedAssistant, isNew]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(formData.email)) {
    setEmailError("Please enter a valid email.");
    return;
  } else {
    setEmailError(""); // Clear error if email is valid
  }
    UpdateAssistantData(formData);
  };

  // const Clear = () => {
  //   setFormData({ name: "", email: "", password: "" }); // Reset all form fields
  // };
  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal-width"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isNew ? "Add Assistant" : "Edit Assistant"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
            <form onSubmit={handleSubmit} className="card mt-1 px-3 py-3">
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    {" "}
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Email<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                  {isSubmitted && emailError && <div className="text-danger">{emailError}</div>}
                </div>
              </div>

              <div className="row mb-3">
                {isNew ? (
                  <div className="col-md-6">
                    <label className="form-label">
                      Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                ) : (
                  <div className="col-md-6">
                    <label className="form-label">
                      Status <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      className="form-select"
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                )}

                <div className="col-md-6">
                  <label className="form-label">
                    Role <span style={{ color: "red" }}>*</span>
                  </label>
                  <RoleDropdown name="role" value={formData.role} onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-end">
                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                    disabled={btnloading}
                  >
                    {btnloading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : isNew ? (
                      "SAVE"
                    ) : (
                      "UPDATE"
                    )}
                  </button>

                  <Button
                    className="me-2"
                    variant="secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default AssistantDetail;
